import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b9326e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-modal-wrapper" }
const _hoisted_2 = {
  ref: "daumPostcode",
  class: "daum-postcode"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: "우편번호 찾기",
      shouldHideBackButton: true,
      onOnClickClose: $setup.closeDaumPostcode
    }),
    _createElementVNode("div", _hoisted_2, null, 512 /* NEED_PATCH */)
  ]))
}